import { PageHero } from "@/components/Section";
import FaqSection from "@/components/home/FaqSection";
import { PortalButton } from "@/components/PortalButton";

export default function FAQPage() {
  return (
    <>
      <PageHero
        chapter="FAQ"
        title="Frequently asked questions"
        lead="Answers to the questions food businesses ask most. Still unsure? Our wholesale team is happy to help."
      >
        <PortalButton variant="butter" testId="faq-open-account-btn">Open a Wholesale Account</PortalButton>
      </PageHero>
      <FaqSection showHeading={false} />
    </>
  );
}
